<script setup>
/**
 * AlertBridgeSetup — AlertProvider 내부에서 useAlert를 bridge에 등록
 * 
 * 이 컴포넌트는 AlertProvider의 자식으로 렌더링되어야 합니다.
 * → useAlert()의 inject가 정상 동작
 * → registerAlert()로 Vue 외부에서 showError() 사용 가능
 */
import { useAlert } from '@/composables/useAlert.js'
import { registerAlert } from '@/utils/alert/alertBridge'

const { error, info } = useAlert()
registerAlert({ error, info })
</script>
<template><!-- 렌더링 없음 --></template>
